import { createRouter, createWebHistory } from 'vue-router';
// ホーム画面
import HomeView from '../views/home/HomeView.vue';
// ログイン画面
import LoginView from '../views/login/LoginView.vue';
//import SetupPasswordApplyView from '../views/setup/SetupPasswordApplyView.vue';
//import SetupPasswordCompleteView from '../views/setup/SetupPasswordCompleteView.vue';
import SetupAgreeView from '../views/setup/SetupAgreeView.vue';
//import SigninMfaView from '../views/signin/SigninMfaView.vue';
import SigninResetApplyView from '../views/signin/SigninResetApplyView.vue';
import SigninResetPasswordView from '../views/signin/SigninResetPasswordView.vue';
import SigninResetCompleteView from '../views/signin/SigninResetCompleteView.vue';
import SigninUseridApplyView from '../views/signin/SigninUseridApplyView.vue';
import SigninUseridCompleteView from '../views/signin/SigninUseridCompleteView.vue';
import FileDownloadView from '@/views/file/FileDownloadView.vue';
// 利用者一覧画面
import ManagementListView from '../views/management/ManagementListView.vue';
import ManagementOrganizationListView from '../views/management/ManagementOrganizationListView.vue';
import ManagementJobCategoryListView from '../views/management/ManagementJobCategoryListView.vue';
import ManagementPositionListView from '../views/management/ManagementPositionListView.vue';
import ManagementEmploymentTypeListView from '../views/management/ManagementEmploymentTypeListView.vue';
import ManagementLocationListView from '../views/management/ManagementLocationListView.vue';
import ManagementOvertimeListView from '../views/management/ManagementOvertimeListView.vue';
import ManagementUploadView from '../views/management/ManagementUploadView.vue';
// 管理者一覧画面
import CompanyManagementListView from '@/views/companyManagement/CompanyManagementListView.vue';
// ハラスメント報告一覧画面
//import HarassmentReportListView from '@/views/harassmentReport/HarassmentReportListView.vue';
// ハラスメント報告書画面
//import HarassmentConsultationReportView from '@/views/harassmentReport/HarassmentConsultationReportView.vue';
// 危機介入報告一覧画面
//import CrisisReportListView from '@/views/crisisReport/CrisisReportListView.vue';
// 危機介入報告書画面
//import CrisisReportView from '@/views/crisisReport/CrisisReportView.vue';
// エラー画面
import ErrorView from '../views/common/ErrorView.vue';
// メンテナンス画面
import MaintenanceView from '../views/common/MaintenanceView.vue';
// ご契約情報/各種設定
import SettingsView from '../views/settings/SettingsView.vue';
// 月次レポート画面
import MonthlyReportView from '../views/monthlyReport/MonthlyReportView.vue';
// 白書データ画面
//import WhitePaperView from '../views/whitePaper/WhitePaperView.vue';
// ユーザー情報確認画面
import UserDetailView from '../views/user/UserDetailView.vue';
// 開示カウンセリング一覧画面
import DisclosureCounselingListView from '../views/disclosureCounseling/DisclosureCounselingListView.vue';
import DisclosureCounselingReportView from '../views/disclosureCounseling/DisclosureCounselingReportView.vue';

// ページが見つかりません画面
import PageNotFoundView from '../views/common/PageNotFoundView.vue';
// Storeでセッション情報を管理する
import { useLoginStore } from '@/stores/login/loginStore';

const routes = [
    {
        // いずれの画面の指定が無い場合。
        path: '/',
        redirect: '/login',
    },
    {
        path: '/home',
        name: 'home',
        component: HomeView,
        meta: { requiresAuth: true },
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
    },
    {
        // ログイン画面
        // SSOログイン時にリダイレクトでメンテナンスモードに設定されていた場合。
        path: '/login3',
        name: 'login3',
        component: LoginView,
    },
    {
        // エラー画面
        path: '/error',
        name: 'error',
        component: ErrorView,
    },
    {
        // メンテナンス画面
        path: '/maintenance',
        name: 'maintenance',
        component: MaintenanceView,
    },
    /*
    {
        // パスワード再設定入力
        path: '/setup/password/apply',
        name: 'setupPasswordApply',
        component: SetupPasswordApplyView,
    },
    {
        // パスワード再設定完了
        path: '/setup/password/complete',
        name: 'setupPasswordComplete',
        component: SetupPasswordCompleteView,
    },
    */
    {
        // 利用規定同意画面
        path: '/setup/agree',
        name: 'setupAgree',
        component: SetupAgreeView,
    },
    /*
    {
        // MFA暗唱コード入力
        path: '/signin/mfa',
        name: 'signinMfa',
        component: SigninMfaView,
    },
    */
    {
        // パスワードリセットID入力
        path: '/signin/reset/apply',
        name: 'signinResetApply',
        component: SigninResetApplyView,
    },
    {
        // パスワードリセット新パスワード入力
        path: '/signin/reset/password',
        name: 'signinResetPassword',
        component: SigninResetPasswordView,
    },
    {
        // パスワードリセット完了
        path: '/signin/reset/complete',
        name: 'signinResetComplete',
        component: SigninResetCompleteView,
    },
    {
        // ユーザーID通知入力
        path: '/signin/userid/apply',
        name: 'signinUseridApply',
        component: SigninUseridApplyView,
    },
    {
        // ユーザーのID通知完了
        path: '/signin/userid/complete',
        name: 'signinUseridComplete',
        component: SigninUseridCompleteView,
    },
    {
        // ファイルダウンロード画面
        path: '/file/download',
        name: 'fileDownload',
        component: FileDownloadView,
        meta: { requiresAuth: true },
    },
    {
        // ご契約情報/各種設定
        path: '/settings',
        name: 'settings',
        component: SettingsView,
        meta: { requiresAuth: true },
    },
    {
        // 利用者一覧画面
        path: '/management/list',
        name: 'managementlist',
        component: ManagementListView,
        meta: { requiresAuth: true },
    },
    {
        // 組織一覧画面
        path: '/management/organization/list',
        name: 'managementorganizationlist',
        component: ManagementOrganizationListView,
        meta: { requiresAuth: true },
    },
    {
        // 職種一覧画面
        path: '/management/jobcategory/list',
        name: 'managementjobcategorylist',
        component: ManagementJobCategoryListView,
        meta: { requiresAuth: true },
    },
    {
        // 職位一覧画面
        path: '/management/position/list',
        name: 'managementpositionlist',
        component: ManagementPositionListView,
        meta: { requiresAuth: true },
    },
    {
        // 雇用形態一覧画面
        path: '/management/employmenttype/list',
        name: 'managementemploymenttypelist',
        component: ManagementEmploymentTypeListView,
        meta: { requiresAuth: true },
    },
    {
        // 勤務地一覧画面
        path: '/management/location/list',
        name: 'managementlocationlist',
        component: ManagementLocationListView,
        meta: { requiresAuth: true },
    },
    {
        // 時間外労働時間一覧画面
        path: '/management/overtime/list',
        name: 'managementovertimelist',
        component: ManagementOvertimeListView,
        meta: { requiresAuth: true },
    },
    {
        // CSVアップロード履歴画面
        path: '/management/upload',
        name: 'managementupload',
        component: ManagementUploadView,
        meta: { requiresAuth: true },
    },
    {
        // 管理者画面
        path: '/companyManagement/list',
        name: 'companyManagementList',
        component: CompanyManagementListView,
        meta: { requiresAuth: true },
    },
    /*
    {
        // ハラスメント報告一覧画面
        path: '/harassmentReport/list',
        name: 'harassmentReportList',
        component: HarassmentReportListView,
        meta: { requiresAuth: true },
    },
    {
        // ハラスメント相談窓口開示用報告書画面
        path: '/harassmentConsultationReport',
        name: 'harassmentConsultationReport',
        component: HarassmentConsultationReportView,
        meta: { requiresAuth: true },
    },
    */
    /*
    {
        // 危機介入報告一覧画面
        path: '/crisisReport/list',
        name: 'crisisReportList',
        component: CrisisReportListView,
        meta: { requiresAuth: true },
    },
    {
        // 危機介入報告書画面
        path: '/crisisReport',
        name: 'crisisReport',
        component: CrisisReportView,
        meta: { requiresAuth: true },
    },
    */
    {
        // 月次レポート画面
        path: '/monthlyReport',
        name: 'monthlyReport',
        component: MonthlyReportView,
        meta: { requiresAuth: true },
    },
    /*
    {
        // 白書データ画面
        path: '/whitePaper',
        name: 'whitePaper',
        component: WhitePaperView,
        meta: { requiresAuth: true },
    },
    */
    {
        // ユーザー情報確認画面
        path: '/user/detail',
        name: 'userDetail',
        component: UserDetailView,
        meta: { requiresAuth: true },
    },
    {
        // 開示カウンセリング一覧画面
        path: '/disclosureCounseling/list',
        name: 'DisclosureCounselingList',
        component: DisclosureCounselingListView,
        meta: { requiresAuth: true },
    },
    {
        // 開示カウンセリングレポート画面
        path: '/disclosureCounseling/report/:sessionGrpPk/:reservationPk',
        name: 'DisclosureCounselingReport',
        component: DisclosureCounselingReportView,
        meta: { requiresAuth: true },
    },
    {
        // メンテナンス画面
        path: '/pageNotFound',
        name: 'pageNotFound',
        component: PageNotFoundView,
    },
    {
        // 上記のURLいずれにもマッチしない場合。
        path: '/:pathMatch(.*)*',
        redirect: '/pageNotFound',
    },
];

// ルーターを生成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const loginStore = useLoginStore();
    const token = await loginStore.isTokenValid();
    // 現在いる画面、もしくは、移動先の画面が、ログイン権限が必要な画面で、かつ、有効なCognitoのセッショントークンが発行されている場合。
    if (to.matched.some((record) => record.meta.requiresAuth) && !token) {
        // Cognitoログアウト処理
        await loginStore.cognitoLogoutAction();
        //next({ path: 'login', query: { vid: loginStore.getVendorId } });
    } else {
        // 有効なCognitoのセッショントークンが存在する場合や、遷移先の画面がログイン権限不要な場合。
        next();
    }
});
export default router;
